<script setup lang="ts">
import IconLoader from '@/domains/common/components/icons/IconLoader.vue';

const { message } = defineProps<{ message?: string }>();
</script>

<template>
    <div class="fixed top-0 z-20 flex h-full w-full flex-col items-center justify-center bg-white bg-white/80">
        <div class="h-28 w-28">
            <IconLoader class="text-black" />
        </div>
        <p class="text-success font-bold">{{ message }}</p>
    </div>
</template>
